/**
 * Google Consent Mode v2 bridge for the custom cookie banner.
 *
 * index.html sets the consent defaults to "denied". When the user makes a
 * choice in the banner we must tell Google via gtag('consent', 'update', ...),
 * otherwise Consent Mode stays denied and Analytics receives no data.
 *
 * gtag/dataLayer are defined in index.html before the app loads.
 */

function gtag() {
  // Reuse the page's dataLayer queue (defined in index.html). Guard for SSR/tests.
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

/**
 * Push the user's consent choice to Google Consent Mode.
 * @param {{ analytics: boolean }} prefs
 */
export function updateConsent(prefs) {
  const granted = prefs && prefs.analytics ? 'granted' : 'denied';
  gtag('consent', 'update', {
    analytics_storage: granted,
    // This app uses analytics only (no ads); keep ad signals denied.
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}
